import { render, staticRenderFns } from "./MessagingAppAtUserInsert.vue?vue&type=template&id=68b1c305&"
import script from "./MessagingAppAtUserInsert.vue?vue&type=script&lang=js&"
export * from "./MessagingAppAtUserInsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports